import React, { Component, } from 'react';
import { withRouter } from 'react-router';
import LoadingOverlay from 'react-loading-overlay';
import placeholder_img from '../profiles/placeholder.png';
import '../styles/Login.css';
import firebase from '../../Firebase';
// import { userInfo } from 'os';

class PhotoChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      url: null,
      completed: false,
      progress: 0,
      response: {
        success: false,
        error: null,
        message: null,
        warning: null,
        loading: false
      }
    };
  }

  triggerClick = () => {
    document.querySelector('#profileImage').click();
  }

  dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {type:mimeString});
}

  ResizeImage = () => {
    // var image = await imagenation(img, 165);
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        var {url, completed} = this.state;
        var filesToUploads = document.getElementById('profileImage').files;
        var file = filesToUploads[0];
        if (file) {
  
          var reader = new FileReader();
          // Set the image once loaded into file reader
          reader.onload = (e) => {

              var img = document.createElement("img");
              img.src = e.target.result;

              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);

              var MAX_WIDTH = 400;
              var MAX_HEIGHT = 400;
              var width = img.width;
              var height = img.height;

              if (width > height) {
                  if (width > MAX_WIDTH) {
                      height *= MAX_WIDTH / width;
                      width = MAX_WIDTH;
                  }
              } else {
                  if (height > MAX_HEIGHT) {
                      width *= MAX_HEIGHT / height;
                      height = MAX_HEIGHT;
                  }
              }
              canvas.width = width;
              canvas.height = height;
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);
              const dataurl = canvas.toDataURL(file.type);
              // document.getElementById('output').src = dataurl;
              completed = true;
              url = dataurl;
              this.setState({ url, completed });
          }
          reader.readAsDataURL(file);
  
        }
        else{
          completed = false;
          url = null;
          this.setState({ url, completed });
        }

   
      } else {
          alert('The File APIs are not fully supported in this browser.');
      }

  }

  displayImage = (e) => {
    if (e.target.files[0]) {
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        document.querySelector('#profileDisplay').setAttribute('src', e.target.result);
        this.ResizeImage();
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  savePhoto = (e) => {
    e.preventDefault();
    var { completed, url, response } = this.state;
    const {user_name} = this.props.User;
    response.loading = true;
    this.setState({ response });

    if(completed) {
    
      if(url === null){
        response.error = "No image selected";
        response.message= null;
        response.warning= null;
        response.loading = false;
        this.setState({ response });
        return;
      }

      const image = this.dataURItoBlob(url);

      var photo_image_type_ok = false;
      switch(image.type)
      {

        case "image/gif": photo_image_type_ok = true; break;

        case "image/jpeg": photo_image_type_ok = true; break;

        case "image/pjpeg": photo_image_type_ok = true; break;

        case "image/png": photo_image_type_ok = true; break;

        case "image/bmp": photo_image_type_ok = true; break;

        default: photo_image_type_ok = false; break;

      }

      if (!photo_image_type_ok){
        response.error = "Photo must be in PNG,JPEG,GIF or BMP format";
        response.message= null;
        response.warning= null;
        response.loading = false;
        this.setState({ response });
        return;
      }

      const storage = firebase.storage();
      const uploadTask = storage.ref(`profiles/${user_name}`).put(image);
      uploadTask.on(
        "state_changed",
        snapshot => {
          // progress function ...
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({ progress });
        },
        error => {
          // Error function ...
          alert(error);
        },
        () => {
          // complete function ...
          storage
            .ref("profiles")
            .child(user_name)
            .getDownloadURL()
            .then(url => {
              const {onPhotoChange} = this.props;
              onPhotoChange(url);
              response.error = null;
              response.message= "profile picture updated";
              response.warning= null;
              document.querySelector('#profileDisplay').setAttribute('src', placeholder_img);
              completed = false;
              url = null;
              response.loading = false;
              this.setState({ response, url, completed });
            });
        }
      );

    };

  }

  render() {
    const {loading, error, success, message, warning} = this.state.response;
    const { image, url, progress} = this.state;
    return (
      <LoadingOverlay active={loading} spinner text={`Processing... (${progress}%)`}>
        
        <div className="container-fluid">
          <div className="row" style={{marginTop: "10px"}}>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="upload-area"  style={{height: "auto",width: "100%",border: "1px dashed",padding: "20px 0px"}}>
                <center>
                  <span className="alert-danger">{error}</span>
                  <span className="alert-success">{message}</span>
                  <span className="alert-warning">{warning}</span>
                </center>
                <form onSubmit={this.savePhoto}>
                  <div className="col-xs-12 text-center">
                    <img style={{textAlign: "center"}} src={placeholder_img} id="profileDisplay" height="150px" width="150px" onClick={this.triggerClick} style={{borderRadius: "50%"}} />
                    <input type="file" name="photo" id="profileImage" style={{display: "none"}} onChange={this.displayImage} accept="image/*" />
                  </div>
                  <div className="col-xs-12 text-center" style={{marginTop: "20px"}}>
                    <button type="submit" name="photo_update" className="btn" style={{background: "hsl(120, 50%, 40%)",width: "100px",color: "#fff",borderRadius: "0px",height: "40px"}}>SAVE</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </LoadingOverlay>
    );
  }
}

export default withRouter(PhotoChange);
export const PhotoChanger = PhotoChange;
